module.exports = __webpack_public_path__ + "static/greyfloralbunny-2ecf0c3e3bde2f3430b33e66c8c373c1.jpeg";